import { render, staticRenderFns } from "./entity-comment.vue?vue&type=template&id=82babc84"
import script from "./entity-comment.vue?vue&type=script&lang=js"
export * from "./entity-comment.vue?vue&type=script&lang=js"
import style0 from "./entity-comment.vue?vue&type=style&index=0&id=82babc84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports